import React from "react";
import { DateAndTimeGridCell } from "../common/DateAndTimeGridCell";
import StatusActiveInactive from "../common/StatusActiveInactive";
import { DISCONNECT_REASONS } from "../../services/Constants";
import { Chip, IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import WifiIcon from "@mui/icons-material/Wifi";
import WifiOffIcon from "@mui/icons-material/WifiOff";

const formatDisconnectReason = (reason) => {
  if (!reason) return "-";
  return DISCONNECT_REASONS[reason] || reason.replace(/_/g, " ");
};

const handleCopy = (value) => {
  if (value && value !== "-") {
    navigator.clipboard.writeText(value);
  }
};

const CopyableCell = ({ value }) => {
  const displayValue = value || "-";
  return (
    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
      <span
        title={displayValue}
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          flex: 1,
        }}
      >
        {displayValue}
      </span>
      {value && (
        <Tooltip title="Copy">
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleCopy(value);
            }}
            sx={{ padding: "2px", marginLeft: "4px" }}
          >
            <ContentCopyIcon fontSize="small" sx={{ fontSize: "14px" }} />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
};

const getLastSeenColumns = () => {
  return [
    {
      field: "serialNo",
      headerName: "Serial No",
      flex: 1,
      renderCell: (d) => <CopyableCell value={d.value} />,
    },
    {
      field: "vehicleKey",
      headerName: "Vehicle Key",
      flex: 1,
      renderCell: (d) => <CopyableCell value={d.value} />,
    },
    {
      field: "vehicleCreationDate",
      headerName: "Vehicle Creation Date",
      type: "dateTime",
      valueGetter: (value) => value ? new Date(value) : null,
      flex: 0.75,
      renderCell: (d) => <DateAndTimeGridCell value={d.value} />,
    },
    {
      field: "lastSeen",
      headerName: "Last Seen",
      type: "dateTime",
      valueGetter: (value) => value ? new Date(value) : null,
      flex: 0.75,
      renderCell: (d) => <DateAndTimeGridCell value={d.value} />,
    },
    {
      field: "eventType",
      headerName: "Event Type",
      flex: 0.5,
      renderCell: (d) => {
        const value = d.value?.toLowerCase();
        if (value === "connected") {
          return (
            <Chip
              icon={<WifiIcon />}
              label="Connected"
              size="small"
              color="success"
              variant="outlined"
              sx={{ fontSize: "12px", borderRadius: "4px" }}
            />
          );
        } else if (value === "disconnected") {
          return (
            <Chip
              icon={<WifiOffIcon />}
              label="Disconnected"
              size="small"
              color="error"
              variant="outlined"
              sx={{ fontSize: "12px", borderRadius: "4px" }}
            />
          );
        }
        return d.value || "-";
      },
    },
    {
      field: "clientIp",
      headerName: "Client IP",
      flex: 0.75,
      renderCell: (d) => <CopyableCell value={d.value} />,
    },
    {
      field: "disconnectReason",
      headerName: "Disconnect Reason",
      flex: 0.75,
      renderCell: (d) => {
        const formattedValue = formatDisconnectReason(d.value);
        return <span title={formattedValue}>{formattedValue}</span>;
      },
    },
    {
      field: "active",
      headerName: "Status",
      type: "boolean",
      flex: 0.5,
      renderCell: (d) => {
        return <StatusActiveInactive active={d.value} />;
      },
    },
  ];
};

export { getLastSeenColumns, DISCONNECT_REASONS };
